/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PublicChatMessageSchemaRole = typeof PublicChatMessageSchemaRole[keyof typeof PublicChatMessageSchemaRole];


export const PublicChatMessageSchemaRole = {
  user: 'user',
  assistant: 'assistant',
} as const;
